/** User participation kind of project to load. Using by tree and list APIs. */
export enum ProjectKindEnum {
  /** Only projects where current user is responsible */
  RESPONSIBLE = 'RESPONSIBLE',
  /** Only projects where current user is creator */
  CREATOR = 'CREATOR',
  /** Only projects where current user is auditor */
  AUDITOR = 'AUDITOR',
  /** Only projects where current user is creator or responsible */
  OWN = 'OWN',
  /** All available projects (users with special permission will receive ALL tenant projects) */
  ALL = 'ALL',
}
